import { SolutionOutlined } from '@ant-design/icons'
import {
  dashboard,
  proposalsListTwo,
  proposalsHistory,
  proposalCheck,
  chat,
  lgpdTerms,
  bacenTerms,
  proposalsListSearch
} from '../routes'

const proposals = {
  name: 'Propostas',
  icon: SolutionOutlined,
  routes: [
    proposalsListSearch,
    proposalsListTwo
  ]
}

const providerRoutes = [
  dashboard,
  proposals,
  proposalsHistory,
  proposalCheck,
  chat,
  lgpdTerms,
  bacenTerms
]

export default providerRoutes
